export const IMAGE = 'Image';
export const VIDEO = 'Video';
export const SLIDESHOW = 'Slideshow';
export const NONE = 'None';
